export const withWhomBoende = [
  'Själv',
  'Andra ungdom/ar på HVB',
  'Kompis/ar utanför HVB',
  'Personal',
  'Personal och ungdomar',
  'Skolpersonal',
  'Vårdnadshavare',
  'God man',
  'Socialtjänst',
  'Hälso- och sjukvård',
  'Psykiatri',
  'Rättsvårdande',
  'Flera aktörer',
  'Annan myndighet',
  'Annan',
];
